import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://yallfasorxlhmjwninew.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlhbGxmYXNvcnhsaG1qd25pbmV3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc3MTYxODUsImV4cCI6MjA2MzI5MjE4NX0.1-MLh1F1qxm2eaFp2IoG6oXV_FdbsUBL6FV2AFarlLg'

export const supabase = createClient(supabaseUrl, supabaseAnonKey) 